import { NuxtAxiosInstance } from '@nuxtjs/axios'
import { parseSearchFiltersToUrl } from '~~/apps/pu-links/domain/SearchUrl'
import { routeToFilters } from '../../pu-links/infrastructure/routeToFilters'
import { SearchFilters } from '../schemas'
import { PopularLocations } from './schemas'

const cachedLocations = {}

export async function setupLocations(
  lang: string,
  ctx: ReturnType<typeof useNuxtApp>,
): Promise<PopularLocations | undefined> {
  const { $route, $axios } = ctx
  if ($route.meta?.isSeo === false) {
    return
  }
  const searchFilters = routeToFilters($route)
  const locations = await getLocations(
    { ...searchFilters, base: undefined },
    $axios,
    lang,
  )
  return locations
}

const EXCLUDED_PARAMS = [
  'av',
  'lat',
  'lng',
  'within',
  'placename',
  'bounds',
  'scroll_to_pitchtype',
  'q',
  'search',
  'type',
  'limit',
  'path',
  'facet',
]

async function getLocations(
  filters: SearchFilters,
  $axios: NuxtAxiosInstance,
  lang: string,
) {
  const rawLocations = await fetchLocations(
    filters.categoryIds || [],
    $axios,
    lang,
  )
  const urlExtension = getUrlExtension(filters)
  const updatedLocations = {
    ...rawLocations,
    locations: rawLocations.locations.map((location) => ({
      ...location,
      url: `${location.url}${urlExtension}`,
    })),
  }
  return updatedLocations
}

async function fetchLocations(
  categories: string[],
  $axios: NuxtAxiosInstance,
  lang: string,
) {
  const queryParams = new URLSearchParams(categories.map((id) => ['type', id]))
  const url = `/_/fallback/${
    lang === 'en-gb' ? '' : `${lang}/`
  }_/popular-locations/?${queryParams.toString()}`
  if (cachedLocations[url]) return cachedLocations[url]
  const response = await $axios.get<PopularLocations>(url, { timeout: 30000 })
  cachedLocations[url] = response.data
  return response.data
}

function getUrlExtension(filters: SearchFilters) {
  const queryParams = new URLSearchParams()
  let urlExtension = ''
  for (const param of parseSearchFiltersToUrl(filters)) {
    if (EXCLUDED_PARAMS.includes(param.filterName)) {
      continue
    }
    queryParams.append(param.filterName, param.filterValue)
  }
  const queryParamsString = queryParams.toString().trim()
  if (queryParamsString) {
    urlExtension = `${urlExtension}?${queryParamsString}`
  }
  return urlExtension
}
